import { create } from "zustand";
import { SyncResults } from "@/types/sync.types";

interface SyncReportDialogState {
  isOpen: boolean;
  results: SyncResults | null;

  openDialog: (results: SyncResults) => void;
  closeDialog: () => void;
}

export const useSyncReportDialogStore = create<SyncReportDialogState>(
  (set) => ({
    isOpen: false,
    results: null,

    openDialog: (results) => set({ isOpen: true, results }),
    closeDialog: () => set({ isOpen: false, results: null }),
  })
);
